<template>
  <aw-spinner />
</template>

<script setup lang="ts">
  import { navigateTo, useNuxtApp, useRoute } from 'nuxt/app';
  import AwSpinner from '~~/common/components/Common/AwSpinner.vue';

  defineOptions({
    name: 'SimplePayPaymentReturn',
  });

  const { $logger } = useNuxtApp();
  const route = useRoute();
  try {
    await navigateTo(`/payment-redirect?transactionNumber=${route.query.trId}&isCardInfoShown=1`, { redirectCode: 302 });
  } catch (err) {
    $logger.error(err);
  }
</script>
